import { Places } from 'src/Constants'
import { ResultadoDetalhadoAnaliseKeys } from '../resultado_detalhado_analise.keys'

export class DialogoResultadoKeys extends ResultadoDetalhadoAnaliseKeys {
    get place() {
        return Places.dialogoResultadoDetalhadoAnalise
    }
}
